import $ from 'jquery';
import cx from 'classnames';
import React from 'react';

import CommentsArea from '../comments/CommentsArea.js';

class MvpPageControls extends React.Component {
  constructor(props) {
    super(props);
    const {mvp, liked} = props;

    this.state = {
      liked: liked || false,
      likes: mvp.likes_cache,
    };
  }

  _like = () => {
    if (!this.props.mvp._links.like) {
      return;
    }
    if (this.state.liked) {
      $.postJSON(this.props.mvp._links.unlike.href).done(data => {
        this.setState({
          liked: false,
          likes: data.likes_cache,
        });
      });
      return;
    }
    $.postJSON(this.props.mvp._links.like.href).done(data => {
      this.setState({
        liked: true,
        likes: data.likes_cache,
      });
    });
  };

  render() {
    const {mvp} = this.props;
    return (
      <div>
        <div className="btn-group btn-group-justified">
          <div className="btn-group">
            {
              mvp._links.share ? (
                <a className="btn btn-default" href={mvp._links.share.href}>
                  <i className="fa fa-share-alt-square"></i> Share
                </a>
              ): (
                <button className="btn btn-default"></button>
              )
            }
          </div>
          <div className="btn-group">
            <button className="btn btn-default" onClick={this._like}>
              <i className={cx('fa', 'fa-arrow-up', {'color-liked': this.state.liked})}></i> {this.state.likes}
            </button>
          </div>
        </div>
        {
          mvp._links.comments ? (
            <CommentsArea source={mvp._links.comments.href} />
          ): null
        }
      </div>
    );
  }
}

export default MvpPageControls;
